'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $s_Lmealorama_SortDirection$__asc__Lmealorama_SortDirection() {
  $m_Lmealorama_SortDirection$();
  return $t_Lmealorama_SortDirection$__asc;
}
export { $s_Lmealorama_SortDirection$__asc__Lmealorama_SortDirection as $s_Lmealorama_SortDirection$__asc__Lmealorama_SortDirection };
function $s_Lmealorama_SortDirection$__dsc__Lmealorama_SortDirection() {
  $m_Lmealorama_SortDirection$();
  return $t_Lmealorama_SortDirection$__dsc;
}
export { $s_Lmealorama_SortDirection$__dsc__Lmealorama_SortDirection as $s_Lmealorama_SortDirection$__dsc__Lmealorama_SortDirection };
/** @constructor */
function $c_Lmealorama_SortDirection$() {
  this.am6 = null;
  $n_Lmealorama_SortDirection$ = this;
  $t_Lmealorama_SortDirection$__asc = new $c_Lmealorama_SortDirection$$anon$3("asc", 0);
  $t_Lmealorama_SortDirection$__dsc = new $c_Lmealorama_SortDirection$$anon$3("dsc", 1);
  this.am6 = new ($d_Lmealorama_SortDirection.r().C)([$s_Lmealorama_SortDirection$__asc__Lmealorama_SortDirection(), $s_Lmealorama_SortDirection$__dsc__Lmealorama_SortDirection()]);
}
export { $c_Lmealorama_SortDirection$ as $c_Lmealorama_SortDirection$ };
$p = $c_Lmealorama_SortDirection$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_SortDirection$;
/** @constructor */
function $h_Lmealorama_SortDirection$() {
}
export { $h_Lmealorama_SortDirection$ as $h_Lmealorama_SortDirection$ };
$h_Lmealorama_SortDirection$.prototype = $p;
$p.b6w = (function() {
  return this.am6.a6();
});
var $d_Lmealorama_SortDirection$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_SortDirection$, "mealorama.SortDirection$", ({
  GZ: 1,
  d: 1,
  S: 1
}));
export { $d_Lmealorama_SortDirection$ as $d_Lmealorama_SortDirection$ };
var $n_Lmealorama_SortDirection$;
function $m_Lmealorama_SortDirection$() {
  if ((!$n_Lmealorama_SortDirection$)) {
    $n_Lmealorama_SortDirection$ = new $c_Lmealorama_SortDirection$();
  }
  return $n_Lmealorama_SortDirection$;
}
export { $m_Lmealorama_SortDirection$ as $m_Lmealorama_SortDirection$ };
/** @constructor */
function $c_Lmealorama_SortDirection() {
}
export { $c_Lmealorama_SortDirection as $c_Lmealorama_SortDirection };
$p = $c_Lmealorama_SortDirection.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_SortDirection;
/** @constructor */
function $h_Lmealorama_SortDirection() {
}
export { $h_Lmealorama_SortDirection as $h_Lmealorama_SortDirection };
$h_Lmealorama_SortDirection.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.b0G = (function() {
  return ((this === $s_Lmealorama_SortDirection$__asc__Lmealorama_SortDirection()) ? $s_Lmealorama_SortDirection$__dsc__Lmealorama_SortDirection() : $s_Lmealorama_SortDirection$__asc__Lmealorama_SortDirection());
});
var $d_Lmealorama_SortDirection = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i(0, "mealorama.SortDirection", ({
  jW: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lmealorama_SortDirection as $d_Lmealorama_SortDirection };
/** @constructor */
function $c_Lmealorama_SortDirection$$anon$3(\u03b4name$6, _$ordinal$6) {
  this.ZD = null;
  this.ZD = \u03b4name$6;
}
export { $c_Lmealorama_SortDirection$$anon$3 as $c_Lmealorama_SortDirection$$anon$3 };
$p = $c_Lmealorama_SortDirection$$anon$3.prototype = new $h_Lmealorama_SortDirection();
$p.constructor = $c_Lmealorama_SortDirection$$anon$3;
/** @constructor */
function $h_Lmealorama_SortDirection$$anon$3() {
}
export { $h_Lmealorama_SortDirection$$anon$3 as $h_Lmealorama_SortDirection$$anon$3 };
$h_Lmealorama_SortDirection$$anon$3.prototype = $p;
$p.q = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.r = (function() {
  return this.ZD;
});
$p.m = (function() {
  return this.ZD;
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.ZD);
});
var $d_Lmealorama_SortDirection$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_SortDirection$$anon$3, "mealorama.SortDirection$$anon$3", ({
  H0: 1,
  jW: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  n: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_SortDirection$$anon$3 as $d_Lmealorama_SortDirection$$anon$3 };
var $t_Lmealorama_SortDirection$__asc = null;
function $u_Lmealorama_SortDirection$__asc(x) {
  $t_Lmealorama_SortDirection$__asc = x;
}
export { $t_Lmealorama_SortDirection$__asc as $t_Lmealorama_SortDirection$__asc, $u_Lmealorama_SortDirection$__asc as $u_Lmealorama_SortDirection$__asc };
var $t_Lmealorama_SortDirection$__dsc = null;
function $u_Lmealorama_SortDirection$__dsc(x) {
  $t_Lmealorama_SortDirection$__dsc = x;
}
export { $t_Lmealorama_SortDirection$__dsc as $t_Lmealorama_SortDirection$__dsc, $u_Lmealorama_SortDirection$__dsc as $u_Lmealorama_SortDirection$__dsc };
//# sourceMappingURL=mealorama.-Sort-Direction.js.map
